import { Injectable } from '@angular/core';

import { BaseService } from './base.service';
import { ChecklistEndpointModel } from '../model/checklist-endpoint.model';

@Injectable()
export class ChecklistEndpointService {

  path = '/checklist-endpoint/';
  pathItem = '/checklist-endpoint-item/';

  constructor(private baseService: BaseService) {}

  findByPk(id: string) {
    return this.baseService.get(this.path, id);
  }

  post(endpoint: ChecklistEndpointModel) {
    return this.baseService.post(this.path, '', endpoint);
  }

  put(endpoint: ChecklistEndpointModel) {
    return this.baseService.put(this.path, '', endpoint);
  }

  deleteList(id: string) {
    return this.baseService.delete(this.path, id);
  }

  saveOrEdit(endpoint: ChecklistEndpointModel) {
    if (endpoint.id) return this.put(endpoint); else return this.post(endpoint);
  }

  // for external routes

  getRequestHeaders(accessToken: string) {
    return Object.assign({
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
        'Accept-Language': 'pt-BR',
      },
    })
  }

	getExternal(externalUrl: string, token: string) {
		return this.baseService.getWithProxy('', externalUrl, {
      Headers: this.getRequestHeaders(token),
    });
	}

}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/service/checklist-endpoint.service.ts